import { useEffect, useState } from 'react'
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts'
import CircularProgress from '@mui/material/CircularProgress';

function IntegrationsChart({chartData}) {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  
  useEffect(() => {
    setLoading(true)
    setTimeout(() => {
      const formateData = chartData.map((record) => {
        const getRandomColor = () => {
          return '#' + Math.floor(Math.random()*16777215).toString(16).padStart(6, '0');
        };
      
        return {
          name: record.apiCallId,
          value: record.avg_duration,
          color: getRandomColor()
        };
      });
      setData(formateData)
      setLoading(false)
    }, 600)
  }, [chartData])
  
  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, name }) => {
    const RADIAN = Math.PI / 180
    const radius = innerRadius + (outerRadius - innerRadius) * 1.1
    const x = cx + radius * Math.cos(-midAngle * RADIAN)
    const y = cy + radius * Math.sin(-midAngle * RADIAN)
    
    return (
      <text 
        x={x} 
        y={y} 
        fill="var(--text-color)" 
        textAnchor={x > cx ? 'start' : 'end'} 
        dominantBaseline="central"
        fontSize={14}
        fontWeight="bold"
      >
        {`${(percent * 100).toFixed(1)}%`}
      </text>
    )
  }
  
  if (loading) {
    return <div className='loading'><CircularProgress color="inherit" /></div>
  }
  
  return (
    <div className="chart-wrapper integrations-chart">
      <div className="pie-legend">
        {data.map((entry) => (
          <div key={entry.name} className="legend-item">
            <div 
              className="legend-color" 
              style={{ backgroundColor:entry.color }}
            />
            <span className="legend-label">{entry.name}</span>
          </div>
        ))}
      </div>
      
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            border={false}
            label={renderCustomizedLabel}
            outerRadius={110}
            innerRadius={60}
            style={{ filter: "url(#innerShadow)" }}
            paddingAngle={0}
            dataKey="value"
            animationDuration={1000}
            animationBegin={200}
          >
           {data.map((entry, index) => (
                <Cell 
                  key={`cell-${index}`} 
                  fill={entry.color} 
                 />
              ))}

          </Pie>
          <Tooltip 
            formatter={(value, name) => [`${value}%`, name]}
            contentStyle={{
              backgroundColor: 'var(--bg-color)', 
              borderColor: '#ccc',
              borderRadius: '4px',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
              padding: '8px 12px',
            }}
            itemStyle={{ color: 'var(--text-color)' }} 
          />
          <defs>
            <radialGradient id="innerShadow" cx="50%" cy="50%" r="50%">
              <stop offset="70%" stopColor="rgba(0, 0, 0, 0.15)" />
              <stop offset="100%" stopColor="rgba(0, 0, 0, 0)" />
            </radialGradient>
          </defs>

        </PieChart>
      </ResponsiveContainer>
    </div>
  )
}

export default IntegrationsChart